/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
const cardsBlueSwiper = new Swiper(".sc-cards-button__cards-mobile", {
	spaceBetween: 16,
	slidesPerView: 1.4,
	rewind: true,
	speed: 500,
	breakpoints: {
		726: {
			slidesPerView: 1.8,
		},
	},
});

import anime from "animejs/lib/anime.es.js";
const cards = document.querySelectorAll(".sc-cards-button__cards__card");
const cardsMobile = document.querySelectorAll(
	".sc-cards-button__cards-mobile__card",
);
let options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.0,
};
function handleCardWatcherEntry(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			animateCard(entry.target);
			observer.unobserve(entry.target);
		}
	});
}

const intersectionWathcer = () => {
	let observerCard = new IntersectionObserver(handleCardWatcherEntry, options);

	cards.forEach((card) => {
		observerCard.observe(card);
	});

	cardsMobile.forEach((card) => {
		observerCard.observe(card);
	});
};

intersectionWathcer();

const animateCard = (card) => {
	anime({
		targets: card,

		opacity: [0, 1],
		easing: "easeOutExpo",
		duration: 500,
		delay: 500,
	});
};
/* eslint-enable no-console */
